import React from 'react';
import styles from './DataProviderSelector.module.scss';

export default function DataProviderListItem(props) {
  const {
    id,
    displayName,
    handleSelection,
    provider,
  } = props;
  return (
    <button
      type="button"
      className={`${styles.dataProviderSearchListItem} list-group-item list-group-item-action rounded-0`}
      onClick={() => handleSelection(id, provider)}
    >
      {displayName}
    </button>
  );
}
